import React, { useState } from "react";
import {
  Button,
  Card,
  Stack,
  Typography,
  // useTheme,
  Grid,
  CardContent,
  CardMedia,
  Box,
  Chip,
  Avatar,
  TextField,
  CircularProgress
  // Alert
} from "@mui/material";
import Slideshow from "../components/SlideShow";
import ValueCard from "../components/ValueCard";
// import FassetAssistant from "../components/FassetAssistant";
import NoticeBoardModal from "../components/NoticeBoardModal";
import StandardImageList from "../components/Gallerry";
import { useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "@tanstack/react-query";
import UserQuery from "../stateQueries/User";
import { format } from "date-fns";
import AlertPopup from "../components/AlertPopup";

const Home = ({ id }) => {
  // const theme = useTheme();
  const navigate = useNavigate();
  const articlesPerPage = 4; // Display 4 articles on the home page
  const [email, setEmail] = useState("");

  const subscribeMutation = useMutation({
    mutationFn: (email) => UserQuery.subscribeToNewsletter({ email })
  });

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["homeArticles", 1, articlesPerPage],
    queryFn: async () => await UserQuery.getAllArticles(1, articlesPerPage)
  });

  const blogPosts = data?.articles?.articles || [];

  const handleSeeMoreBlogs = () => {
    navigate("/articles");
  };

  return (
    <Stack spacing={2} width="100%">
      {/* <DesktopBanner /> */}

      <Slideshow />
      <NoticeBoardModal />
      {/* <FassetAssistant /> */}

      {/* Values Section */}
      <Box sx={{ py: 2, px: { xs: 2, md: 2, lg: 8 } }}>
        <Typography
          variant="h3"
          component="h2"
          textAlign="center"
          fontWeight="bold"
          sx={{
            color: "primary.main",
            mb: 1,
            fontSize: { xs: "2rem", md: "2.5rem", lg: "3rem" }
          }}
        >
          Our Values
        </Typography>
        <Typography
          variant="h6"
          textAlign="center"
          sx={{
            color: "text.secondary",
            mb: 6,
            mx: "auto",
            px: 2
          }}
        >
          The core principles that guide our mission and drive excellence in
          everything we do
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6} md={2.4} lg={2.4}>
            <ValueCard
              title="Professionalism & Accountability"
              definition={
                "We are a high-performance, professional team; we strive for excellence through hard work and by taking responsibility and being accountable within an accepted and agreed code of conduct."
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4}>
            <ValueCard
              title="Ethics"
              definition="We work with integrity and honesty and respect internal and external stakeholders at all times."
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4}>
            <ValueCard
              title="Making A Difference"
              definition={
                "We make a difference to the lives of all our stakeholders by identifying their needs and exceeding expectations."
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4}>
            <ValueCard
              title="Valuing People"
              definition={
                "We strive to create a motivating and supportive culture by understanding, respecting, developing and valuing each other."
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2.4} lg={2.4}>
            <ValueCard
              title="Innovation"
              definition="We Continuously innovate and improve to add value to all our stakeholders. The Work of Setas"
            />
          </Grid>
        </Grid>
      </Box>

      {/* Gallery Section */}
      <Box sx={{ py: 2, px: { xs: 2, md: 2, lg: 8 } }}>
        <Typography
          variant="h3"
          component="h2"
          textAlign="center"
          fontWeight="bold"
          sx={{
            color: "primary.main",
            mb: 1,
            fontSize: { xs: "2rem", md: "2.5rem", lg: "3rem" }
          }}
        >
          Our Gallery
        </Typography>
        <Typography
          variant="h6"
          textAlign="center"
          sx={{
            color: "text.secondary",
            mb: 2,
            maxWidth: 600,
            mx: "auto",
            px: 2
          }}
        >
          Explore our visual journey through impactful moments and achievements
        </Typography>

        <StandardImageList />
      </Box>

      {/* Newsletter Signup Section */}
      <Box sx={{ py: 2, px: { xs: 2, md: 2, lg: 8 } }}>
        <Typography
          variant="h3"
          component="h2"
          textAlign="center"
          fontWeight="bold"
          sx={{
            color: "primary.main",
            mb: 1,
            fontSize: { xs: "2rem", md: "2.5rem", lg: "3rem" }
          }}
        >
          Newsletter Signup
        </Typography>
        <Typography
          variant="h6"
          textAlign="center"
          sx={{
            color: "text.secondary",
            mb: 2,
            maxWidth: 600,
            mx: "auto",
            px: 2
          }}
        >
          Stay connected with the latest insights and developments in the
          financial services sector
        </Typography>

        <Box
          sx={{
            backgroundColor: "primary.main",
            borderRadius: 3,
            p: { xs: 5, md: 7 },
            textAlign: "center",
            position: "relative",
            overflow: "hidden",
            boxShadow: "0 25px 50px rgba(0,0,0,0.15)"
          }}
        >
          <Box sx={{ position: "relative", zIndex: 2 }}>
            <Typography
              variant="h4"
              component="h3"
              fontWeight="bold"
              sx={{
                color: "white",
                mb: 2,
                fontSize: { xs: "1.75rem", md: "2rem", lg: "2.25rem" },
                textShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}
            >
              Never Miss an Update!
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: "rgba(255,255,255,0.95)",
                mb: 1,
                maxWidth: 600,
                mx: "auto",
                lineHeight: 1.6,
                fontWeight: 500
              }}
            >
              Get exclusive insights, industry trends, and FASSET updates
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "rgba(255,255,255,0.8)",
                mb: 5,
                maxWidth: 500,
                mx: "auto",
                lineHeight: 1.6
              }}
            >
              Join thousands of professionals staying ahead in financial
              services
            </Typography>

            {subscribeMutation.isSuccess && (
              <AlertPopup
                open={true}
                severity="success"
                message="Successfully subscribed to the newsletter!"
              />
            )}

            {subscribeMutation.isError && (
              <AlertPopup
                open={true}
                severity="error"
                message={
                  subscribeMutation.error?.response?.data?.message ||
                  "Server Error"
                }
              />
            )}

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={3}
              justifyContent="center"
              alignItems="stretch"
              sx={{ maxWidth: 550, mx: "auto", mb: 4 }}
            >
              <TextField
                placeholder="Your email address"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                  flex: 1,
                  minWidth: { xs: "100%", sm: "350px" },
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "rgba(255,255,255,0.95)",
                    borderRadius: 4,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                    height: "56px",
                    "& fieldset": {
                      borderColor: "transparent"
                    },
                    "&:hover fieldset": {
                      borderColor: "rgba(255,255,255,0.5)"
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "white",
                      borderWidth: 2
                    }
                  },
                  "& .MuiInputBase-input": {
                    py: 2,
                    px: 3,
                    fontSize: "1.1rem",
                    fontWeight: 500
                  }
                }}
              />
              <Button
                variant="contained"
                color="secondary"
                onClick={() => subscribeMutation.mutate(email)}
                disabled={subscribeMutation.isLoading}
                sx={{ fontWeight: "bolder" }}
              >
                {subscribeMutation.isLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Subscribe Now"
                )}
              </Button>
            </Stack>

            {/* Benefits */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: 3,
                mb: 3
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(255,255,255,0.9)",
                    fontWeight: 500
                  }}
                >
                  ✅ Weekly insights
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(255,255,255,0.9)",
                    fontWeight: 500
                  }}
                >
                  ✅ Industry updates
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(255,255,255,0.9)",
                    fontWeight: 500
                  }}
                >
                  ✅ Exclusive content
                </Typography>
              </Box>
            </Box>

            <Typography
              variant="body2"
              sx={{
                color: "rgba(255,255,255,0.7)",
                fontSize: "0.875rem",
                fontStyle: "italic"
              }}
            >
              🔒 100% free • Unsubscribe anytime • No spam
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Blog Section - Outside conditional rendering */}
      <Box data-section="blogs" sx={{ py: 2, px: { xs: 2, md: 4, lg: 8 } }}>
        <Typography
          variant="h3"
          component="h2"
          textAlign="center"
          fontWeight="bold"
          sx={{
            color: "primary.main",
            mb: 1,
            fontSize: { xs: "2rem", md: "2.5rem", lg: "3rem" }
          }}
        >
          Latest Articles
        </Typography>
        <Typography
          variant="h6"
          textAlign="center"
          sx={{
            color: "text.secondary",
            mb: 2,
            maxWidth: 600,
            mx: "auto",
            px: 2
          }}
        >
          Stay updated with the latest insights, trends, and developments in the
          financial services sector
        </Typography>

        {isLoading ? (
          <Box sx={{ textAlign: "center", py: 8 }}>
            <CircularProgress color="primary" size={60} />
            <Typography variant="h6" color="text.secondary" sx={{ mt: 2 }}>
              Loading articles...
            </Typography>
          </Box>
        ) : isError ? (
          <Box sx={{ textAlign: "center", py: 8 }}>
            <AlertPopup
              open={true}
              severity="error"
              message={error.message || "Error fetching articles"}
            />
            <Button
              variant="outlined"
              onClick={() => window.location.reload()}
              sx={{ mt: 2 }}
            >
              Retry
            </Button>
          </Box>
        ) : (
          <Grid container spacing={3} sx={{ mb: 4 }}>
            {blogPosts.map((post) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={post.id}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    transition: "all 0.3s ease-in-out",
                    "&:hover": {
                      transform: "translateY(-8px)",
                      boxShadow: "0 20px 40px rgba(0,0,0,0.1)"
                    },
                    borderRadius: 3,
                    overflow: "hidden",
                    cursor: "pointer"
                  }}
                  onClick={() => navigate(`/article/${post.id}`)}
                >
                  <CardMedia
                    component="img"
                    height="200"
                    image={`${process.env.REACT_APP_API_URL}/uploads/newsletters/${post.imageURL}`}
                    alt={post.title}
                    sx={{ objectFit: "cover" }}
                  />
                  <CardContent sx={{ flexGrow: 1, p: 3 }}>
                    <Chip
                      label={
                        post.tags && post.tags.length > 0
                          ? JSON.parse(post.tags[0]).label
                          : ""
                      }
                      size="small"
                      sx={{
                        backgroundColor: "primary.light",
                        color: "white",
                        mb: 2,
                        fontWeight: 500
                      }}
                    />
                    <Typography
                      variant="h6"
                      component="h3"
                      fontWeight="bold"
                      sx={{
                        mb: 2,
                        lineHeight: 1.3,
                        fontSize: { xs: "1rem", md: "1.1rem" },
                        minHeight: "2.6em",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden"
                      }}
                    >
                      {post.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        mb: 3,
                        lineHeight: 1.6,
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden"
                      }}
                    >
                      {post.subTitle}
                    </Typography>

                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Avatar
                        sx={{
                          width: 24,
                          height: 24,
                          fontSize: "0.75rem",
                          backgroundColor: "primary.main",
                          mr: 1
                        }}
                      >
                        {post.author.charAt(0)}
                      </Avatar>
                      <Typography variant="caption" color="text.secondary">
                        {post.author}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}
                    >
                      <Typography variant="caption" color="text.secondary">
                        {format(new Date(post.createdAt), "MMMM dd, yyyy")}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="primary.main"
                        fontWeight="500"
                      >
                        {`${post.readTimeValue} ${post.readTimeUnit}`}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        <Box sx={{ textAlign: "center" }}>
          <Button variant="outlined" size="large" onClick={handleSeeMoreBlogs}>
            See More Articles
          </Button>
        </Box>
      </Box>
    </Stack>
  );
};

export default Home;
